import apiClient from '../apiClient';

// Contacts API calls

export const getContacts = (username, password) => {
  return apiClient.get('/api/contacts', {
    auth: { username, password },
  });
};
